document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".pdp-accordion");

  accordions.forEach(acc => {
    const header = acc.querySelector(".accordion-header");
    const content = acc.querySelector(".accordion-content");
 

    header.addEventListener("click", () => {

      // Toggle active class for animation
      header.classList.toggle("active");

      // Slide animation
      if (content.style.maxHeight) {
        content.style.maxHeight = null;     // close
      } else {
        content.style.maxHeight = content.scrollHeight + "px";  // open
      }

    
    });
  });
});
